/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiCompanyApiKeyFromJSON(json) {
    return StreemApiCompanyApiKeyFromJSONTyped(json, false);
}
export function StreemApiCompanyApiKeyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'apiKeyId': !exists(json, 'api_key_id') ? undefined : json['api_key_id'],
        'apiKeySecret': !exists(json, 'api_key_secret') ? undefined : json['api_key_secret'],
        'expiresAt': !exists(json, 'expires_at') ? undefined : (new Date(json['expires_at'])),
        'companySid': !exists(json, 'company_sid') ? undefined : json['company_sid'],
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}
export function StreemApiCompanyApiKeyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'api_key_id': value.apiKeyId,
        'api_key_secret': value.apiKeySecret,
        'expires_at': value.expiresAt === undefined ? undefined : (value.expiresAt.toISOString()),
        'company_sid': value.companySid,
        'label': value.label,
    };
}
//# sourceMappingURL=StreemApiCompanyApiKey.js.map